import BaseService from "./BaseService.js";

class NotificationService extends BaseService {
  get({ status = 'unread' }) {
    return this.apiGet({
      url: `/notifications`,
      params: {
        status,
      },
    });
  }

  readAll() {
    return this.apiPut({
      url: `/notifications/read/all`,
    });
  }

  readOne(id) {
    return this.apiPut({
      url: `/notifications/read/${id}`,
    });
  }
}

export default new NotificationService();
